/**
 * Run an analytics call without letting it take the app down.
 *
 * Telemetry SDKs fail in ways that have nothing to do with our code: Clarity's
 * snippet may not be installed (local dev, self-hosted, ad blockers), leaving
 * `window.clarity` undefined so `Clarity.identify` throws; PostHog can throw
 * for the same class of reason. Where those calls live matters:
 *
 *   - inside an effect, a throw unmounts the tree into the nearest error
 *     boundary — a user who just signed up sees an error screen flash;
 *   - inside a click handler, a throw skips the rest of the handler, so a
 *     dialog never closes or a navigation never happens, and the button
 *     simply looks dead.
 *
 * Both have shipped here. Wrap every analytics call.
 */
export const bestEffortAnalytics = (operation: () => void): void => {
  try {
    operation();
  } catch {
    // Intentionally swallowed — telemetry is not worth an outage.
  }
};
